import { strings } from "utils/localizedStrings";
import { GeneralRangeType } from "../interfaces/IGenerals";

export class GeneralPeriodLabelMappers {
  private constructor() {}

  static formatPeriodLabel = (time: string, range: GeneralRangeType) => {
    const trimmed = String(time).trim();
    const weekNum = Number(trimmed);
    const d = new Date(trimmed);
    const isValidDate = !isNaN(d.getTime());

    if (range === "day") {
      if (!isValidDate) return trimmed;
      return time;
    }

    if (range === "week") {
      if (!isNaN(weekNum) && /^\d+$/.test(trimmed)) {
        return `${strings.General.Revenue.WeekOfYear} ${weekNum}`;
      }
      if (!isValidDate) return trimmed;
      const dayIdx = d.getDay();
      const diff = (dayIdx === 0 ? -6 : 1) - dayIdx;
      d.setDate(d.getDate() + diff);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${strings.General.Revenue.WeekOfYear} ${day}-${month}-${year}`;
    }

    if (!isValidDate) return trimmed;
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}-${year}`;
  };
}